import * as React from 'react'
import cx from 'classnames'
import styles from './SearchResultItem.sass'
import Icon from 'components/Icon'

interface Props extends React.HTMLProps<HTMLDivElement> {
  children?: React.ReactNode
  visual?: React.ReactNode
  highlighted: boolean
  selected: boolean
}

export default React.forwardRef(function SearchResultItem(
  { children, visual, highlighted, className, selected, ...rest }: Props,
  ref: React.Ref<any>,
) {
  return (
    <div
      ref={ref}
      className={cx(
        className,
        styles.root,
        highlighted && styles.highlighted,
        selected && styles.selected,
      )}
      {...rest}
    >
      {visual && <div className={styles.visual}>{visual}</div>}
      <div className={styles.text}>{children}</div>
      <div className={cx(styles.checkedContainer, selected && styles.selected)}>
        <Icon auto name="tick" />
      </div>
    </div>
  )
})
